import { Pipe, PipeTransform } from '@angular/core';
import { PropertyPath, has } from 'lodash';

@Pipe({
  name: 'has',
  standalone: true,
})
export class HasPipe implements PipeTransform {
  transform(value: unknown, path: PropertyPath): boolean {
    return has(value, path);
  }
}
